export const SPACER_CONSTANT = 10
export const HORIZONTAL = 'horizontal'
export const ITERATOR = -1
export const DROPDOWN_ARROW = 24
